import getAppConfig from "~/utils/getAppConfig"
import useFetchResource from "~/hooks/useFetchResource"
import { apiClients } from "~/routes"

import PageTitle from "~/library/PageTitle"
import LoadingWrapper from "~/library/LoadingWrapper"
import CatchCard from "~/library/CatchCard"
import Pagination from "~/library/Pagination"
import CatchTable from "~/library/CatchTable"
import NavigationLink from "~/library/NavigationLink"
import Client from "~/types/Client"

const ClientList = () => {
  const { venueSlug } = getAppConfig()

  const {
    data: clients,
    refetch,
    metadata,
    isLoading,
  } = useFetchResource<{ clients: Client[] }, "clients">(
    apiClients.index.path({ venueSlug }),
    "clients",
    { page: "1" }
  )

  const handlePageChange = (page: string) => {
    refetch({ page: page })
  }

  return (
    <LoadingWrapper isLoading={isLoading}>
      <PageTitle title="Clients" />
      <CatchCard className={"card-dark-theme"}>
        <CatchTable
          data={clients}
          emptyMessage="No Clients"
          columns={[
            {
              key: "name",
              header: "Name",
              formatter: (name, data) => (
                <NavigationLink type="clients" to={`/clients/${data.id}`}>
                  {name}
                </NavigationLink>
              ),
            },
            {
              key: "email",
              header: "Email",
            },
            {
              key: "phone",
              header: "Phone",
            },
          ]}
        />
        {metadata && (
          <Pagination
            metadata={metadata}
            onPageChange={(page: number) => handlePageChange(page.toString())}
          />
        )}
      </CatchCard>
    </LoadingWrapper>
  )
}

export default ClientList
